import React from 'react';
import { Box } from '@mui/material';
import SearchBar from '../../../../ui/primitives/SearchBar';
import CustomSelect from '../../../../ui/primitives/CustomSelect';

const LinkedTestCaseActions = ({
  searchValue,
  setSearchValue,
  selectedTestSuite,
  setSelectedTestSuite,
  testSuites,
}) => {
  const suiteOptions = [
    { id: 'all', name: 'All Test Suites' },
    ...(testSuites || []),
  ];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <SearchBar
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        clearSearch={() => setSearchValue('')}
        placeholder="Search Test Cases"
        width={320}
      />
      <Box sx={{ minWidth: 220 }}>
        <CustomSelect
          value={selectedTestSuite}
          onChange={(val) => setSelectedTestSuite(val)}
          options={suiteOptions}
        />
      </Box>
    </Box>
  );
};

export default LinkedTestCaseActions;
